// crm namespace — Import wizard and the Clients import banner.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "import.autoDetected": "Détecté automatiquement",
    "import.bannerDone": "Import terminé — {new} nouveaux, {merged} fusionnés, {skipped} ignorés",
    "import.bannerFailed": "L'import n'a pas abouti. Relancez-le depuis Importer.",
    "import.bannerLabel": "Import :",
    "import.bannerRunning": "Import de {processed} sur {total}…",
    "import.browse": "Parcourir",
    "import.consentHint": "L'import se fait dans les deux cas ; les séquences marketing n'écrivent qu'aux clients consentants.",
    "import.consentPermission": "J'ai la permission d'écrire à ces clients",
    "import.consentReceived": "Ces clients ont déjà reçu des e-mails de ma part",
    "import.downloadSkipped": "Télécharger les lignes ignorées",
    "import.drop": "Déposez un CSV / XLSX",
    "import.duplicates": "{n} lignes correspondent à des clients existants",
    "import.duplicatesMore": "… et {n} de plus, traitées par Tout fusionner / Tout ignorer",
    "import.enterAs": "Entrent comme :",
    "import.field.birthday": "anniversaire",
    "import.field.email": "e-mail",
    "import.field.first_name": "prénom",
    "import.field.last_name": "nom de famille",
    "import.field.name": "nom",
    "import.field.phone": "téléphone",
    "import.field.skip": "ignorer",
    "import.field.tags": "étiquettes",
    "import.intro": "Importez votre liste de clients en une fois : cinq étapes, avec Retour et Suivant à chaque écran.",
    "import.mapHint": "Le nom et l'e-mail sont détectés automatiquement. Les colonnes non associées sont ignorées.",
    "import.mapLabel": "Champ CRM pour la colonne {column}",
    "import.max": "{n} lignes maximum",
    "import.merge": "Fusionner",
    "import.mergeAll": "Tout fusionner",
    "import.nextHint": "Suivant est désactivé tant que l'e-mail n'est pas associé",
    "import.rowsDetected": "{n} lignes détectées",
    "import.skip": "Ignorer",
    "import.skipAll": "Tout ignorer",
    "import.start": "Lancer l'import",
    "import.started": "Import lancé — suivez-le dans la liste des clients",
    "import.stepConfirm": "Confirmer",
    "import.stepConsent": "Consentement",
    "import.stepDuplicates": "Doublons",
    "import.stepMap": "Colonnes",
    "import.stepUpload": "Fichier",
    "import.summary": "{new} nouveaux · {merged} fusionnés · {skipped} ignorés",
    "import.title": "Importer des clients",
  },
  en: {
    "import.autoDetected": "Detected automatically",
    "import.bannerDone": "Import complete — {new} new, {merged} merged, {skipped} skipped",
    "import.bannerFailed": "The import did not finish. Try it again from Import.",
    "import.bannerLabel": "Import:",
    "import.bannerRunning": "Importing {processed} of {total}…",
    "import.browse": "Browse",
    "import.consentHint": "The import proceeds either way; marketing sequences only ever send to consented clients.",
    "import.consentPermission": "I have permission to email these clients",
    "import.consentReceived": "These clients have received emails from me before",
    "import.downloadSkipped": "Download skipped rows",
    "import.drop": "Drop CSV / XLSX",
    "import.duplicates": "{n} rows match existing clients",
    "import.duplicatesMore": "…and {n} more, handled by Merge all / Skip all",
    "import.enterAs": "Enter as:",
    "import.field.birthday": "birthday",
    "import.field.email": "email",
    "import.field.first_name": "first name",
    "import.field.last_name": "last name",
    "import.field.name": "name",
    "import.field.phone": "phone",
    "import.field.skip": "skip",
    "import.field.tags": "tags",
    "import.intro": "Bring your existing client list in one sitting: five steps, Back and Next throughout.",
    "import.mapHint": "Name and email are detected automatically. Unmapped columns are skipped.",
    "import.mapLabel": "CRM field for the column {column}",
    "import.max": "Max {n} rows",
    "import.merge": "Merge",
    "import.mergeAll": "Merge all",
    "import.nextHint": "Next disabled until email is mapped",
    "import.rowsDetected": "{n} rows detected",
    "import.skip": "Skip",
    "import.skipAll": "Skip all",
    "import.start": "Start import",
    "import.started": "Import started — follow it on the Clients list",
    "import.stepConfirm": "Confirm",
    "import.stepConsent": "Consent",
    "import.stepDuplicates": "Duplicates",
    "import.stepMap": "Map columns",
    "import.stepUpload": "Upload",
    "import.summary": "{new} new · {merged} merged · {skipped} skipped",
    "import.title": "Import clients",
  },
  es: {
    "import.autoDetected": "Detectado automáticamente",
    "import.bannerDone": "Importación completada: {new} nuevos, {merged} fusionados, {skipped} omitidos",
    "import.bannerFailed": "La importación no terminó. Vuelve a lanzarla desde Importar.",
    "import.bannerLabel": "Importación:",
    "import.bannerRunning": "Importando {processed} de {total}…",
    "import.browse": "Examinar",
    "import.consentHint": "La importación sigue en ambos casos; las secuencias de marketing solo escriben a clientes con consentimiento.",
    "import.consentPermission": "Tengo permiso para escribir a estos clientes",
    "import.consentReceived": "Estos clientes ya han recibido correos míos",
    "import.downloadSkipped": "Descargar filas omitidas",
    "import.drop": "Suelta un CSV / XLSX",
    "import.duplicates": "{n} filas coinciden con clientes existentes",
    "import.duplicatesMore": "… y {n} más, según Fusionar todo / Omitir todo",
    "import.enterAs": "Entran como:",
    "import.field.birthday": "cumpleaños",
    "import.field.email": "correo",
    "import.field.first_name": "nombre de pila",
    "import.field.last_name": "apellido",
    "import.field.name": "nombre",
    "import.field.phone": "teléfono",
    "import.field.skip": "omitir",
    "import.field.tags": "etiquetas",
    "import.intro": "Trae tu lista de clientes de una vez: cinco pasos, con Atrás y Siguiente en cada uno.",
    "import.mapHint": "El nombre y el correo se detectan automáticamente. Las columnas sin asignar se omiten.",
    "import.mapLabel": "Campo del CRM para la columna {column}",
    "import.max": "Máximo {n} filas",
    "import.merge": "Fusionar",
    "import.mergeAll": "Fusionar todo",
    "import.nextHint": "Siguiente está desactivado hasta asignar el correo",
    "import.rowsDetected": "{n} filas detectadas",
    "import.skip": "Omitir",
    "import.skipAll": "Omitir todo",
    "import.start": "Iniciar importación",
    "import.started": "Importación iniciada: síguela en la lista de clientes",
    "import.stepConfirm": "Confirmar",
    "import.stepConsent": "Consentimiento",
    "import.stepDuplicates": "Duplicados",
    "import.stepMap": "Columnas",
    "import.stepUpload": "Archivo",
    "import.summary": "{new} nuevos · {merged} fusionados · {skipped} omitidos",
    "import.title": "Importar clientes",
  },
};
